import ChangeAllPlacementCard from 'Components/Editor/Details/ChangeAllPlacements/ChangeAllPlacementCard';
import ChangeAllPlacementSlider from 'Components/Editor/Details/ChangeAllPlacements/ChangeAllPlacementSlider';
import { DetectionPerspectiveSpecification } from 'Models/Project/ProjectFilterSpecifications';
import EditorVideoDetection from 'Models/Videos/Detections/EditorVideoDetection';
import { ReactElement } from 'react';

interface ChangeAllPlacementCardPerspectiveProps {
	perspective: DetectionPerspectiveSpecification | null;
	onPerspectiveChanged: (perspective: DetectionPerspectiveSpecification | null) => void;
	selectedDetections: EditorVideoDetection[];
}

const INITIAL_PERSPECTIVE_VALUE: DetectionPerspectiveSpecification = { from: 0, to: 0 };

const ChangeAllPlacementCardPerspective = (props: ChangeAllPlacementCardPerspectiveProps): ReactElement => {
	const isChecked = props.perspective !== null;
	const fromValue = props.perspective?.from ?? 0;
	const toValue = props.perspective?.to ?? 0;

	const marks = Array.from(Array(5).keys()).map((x) => ({
		value: x * 45,
		label: `${x * 45}°`,
	}));

	const handlePlacementCardCheckedChanged = (checked: boolean): void => {
		const defaultValue = INITIAL_PERSPECTIVE_VALUE;
		if (props.selectedDetections.length > 0) {
			defaultValue.from = props.selectedDetections.reduce(
				(acc, x) => (x.perspective < acc ? x.perspective : acc),
				Number.MAX_SAFE_INTEGER
			);
			defaultValue.to = props.selectedDetections.reduce((acc, x) => (x.perspective > acc ? x.perspective : acc), 0);
		}
		if (checked) props.onPerspectiveChanged(defaultValue);
		else props.onPerspectiveChanged(null);
	};

	const setValues = (from: number, to: number): void => {
		props.onPerspectiveChanged({ from, to });
	};

	return (
		<ChangeAllPlacementCard
			name="Select perspective"
			onCheckedChanged={handlePlacementCardCheckedChanged}
			isChecked={isChecked}
		>
			<ChangeAllPlacementSlider
				label="Perspective"
				fromValue={fromValue}
				toValue={toValue}
				min={0}
				max={180}
				marks={marks}
				onValuesChanged={setValues}
			/>
		</ChangeAllPlacementCard>
	);
};

export default ChangeAllPlacementCardPerspective;
